import _objectSpread from'@babel/runtime/helpers/objectSpread2';import {useContext,useMemo}from'react';import {useIntl}from'react-intl';import {LANG}from'@manulife/mux';import CoBrandingContext from'../components/CoBranding/CoBrandingContext.js';function useCoBranding() {
  var intl = useIntl();
  var coBranding = useContext(CoBrandingContext);
  var cleanedCoBranding = useMemo(function () {
    var brand = (coBranding === null || coBranding === void 0 ? void 0 : coBranding.brand) || {};
    var langBrand = brand[intl.locale] || brand[LANG.EN_CA] || {};
    var contactUrl;
    var accessibilityUrl;
    var privacyPolicyUrl = null;
    try {
      // Validate contact us url is formatted correctly
      contactUrl = new URL(langBrand.contactUrl).href;
      accessibilityUrl = new URL(langBrand.accessibilityUrl).href;
      privacyPolicyUrl = new URL(langBrand.privacyPolicyUrl).href;
    } catch (_unused) {
      // Do nothing and fall back to no contact url if it is invalid
    }
    return _objectSpread(_objectSpread({}, coBranding), {}, {
      brand: _objectSpread(_objectSpread({}, langBrand), {}, {
        contactUrl: contactUrl,
        accessibilityUrl: accessibilityUrl,
        privacyPolicyUrl: privacyPolicyUrl
      })
    });
  }, [coBranding, intl.locale]);
  if (!coBranding) {
    return null;
  }
  return cleanedCoBranding;
}export{useCoBranding as default};